import React, { useContext, useEffect, useState } from "react";
import AccessDetailModal from "../../../modals/AccessDetailModal";
import UserContext from "../../../utils/Contexts/UserContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import moment from "moment";
import EditIcon from "../../svg/Edit";
import DeleteIcon from "../../svg/Delete";
import WordpressIcon from "../../svg/Wordpress";

function AccessDetailsSection({ id, domain }) {
  const { userData } = useContext(UserContext);
  const [accessDetailsData, setAccessDetailsData] = useState([]);
  const [selectedCreds, setSelectedCreds] = useState(null);
  const [modalState, setModalState] = useState(false);
  const [hoverItem, setHoverItem] = useState(null);
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);

  useEffect(() => {
    getAccessDetailsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getAccessDetailsData = () => {
    const url = `/sellers/${userData?.uuid}/domains/${id}/credentials`;
    axiosInstance
      .get(url)
      .then((response) => {
        setAccessDetailsData(response?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching the credential data"));
      });
  };

  const handleDelete = (uuid) => {
    const url = `/sellers/${userData?.uuid}/domains/${id}/credentials/${uuid}`;
    axiosInstance
      .delete(url)
      .then(() => {
        toast.success(t("Credentials deleted successfully"));
        getAccessDetailsData();
      })
      .catch(() => {
        toast.error(t("There was an error deleting Credentials"));
      });
  };

  const [visibleSecrets, setVisibleSecrets] = useState({});
  const toggleSecretVisibility = (uuid) => {
    setVisibleSecrets((prevState) => ({
      ...prevState,
      [uuid]: !prevState[uuid],
    }));
  };

  const formatFromNow = (date) => {
    const fromNowText = moment(date).fromNow();
    const mappings = {
      seconds: t("seconds"),
      minute: t("minute"),
      minutes: t("minutes"),
      hour: t("hour"),
      hours: t("hours"),
      day: t("day"),
      days: t("days"),
      month: t("month"),
      months: t("months"),
      year: t("year"),
      years: t("years"),
      ago: t("ago"),
    };

    // Replace text units with localized values
    return fromNowText
      .split(" ")
      .map((word) => mappings[word] || word)
      .join(" ");
  };

  return (
    <>
      <div id="accessDetailsSection" className="card card-setting">
        <div className="card-header">
          <h4 className="card-title">{t("Access Details")}</h4>
        </div>

        <div className="card-body">
          <p className="card-text text-secondary">
            {t(
              "Access Details is an experimental feature designed to help sellers automate their guest post submissions or link insertion routines, set to launchsoon. By providing your Access Details, You can join the first group of users to benefit from this automation feature."
            )}
          </p>

          <div className="d-flex flex-column justify-content-between">
            {!!accessDetailsData.length &&
              accessDetailsData.map((data, index) => (
                <div
                  className={`my-2 py-3 ${
                    data?.primary === true
                      ? "bg-soft-secondary"
                      : "bg-access-detail-dark"
                  } rounded`}
                  key={data?.uuid}
                >
                  <div className="px-3 py-0 pb-3 pb-sm-0 d-flex justify-content-between">
                    <div>
                      <i className="fs-1">
                        <WordpressIcon />
                      </i>
                      <h5
                        style={{
                          paddingTop: "12px",
                          paddingBottom: "3px",
                          margin: "unset",
                        }}
                        className={`responsive-text ${
                          data?.type === 2 && selectedTheme !== "dark"
                            ? "text-primary"
                            : "text-dark !important"
                        }`}
                      >
                        {data?.type === 1
                          ? t("Wordpress API")
                          : t("Wordpress Account")}
                      </h5>
                      <span
                        className={`responsive-text ${
                          data?.primary === true ? "text-dark" : "text-white"
                        }`}
                      >
                        {visibleSecrets[data?.uuid]
                          ? `${data?.key} / ${data?.secret}`
                          : `${data?.key} / xxxxxxx`}{" "}
                        <i
                          className={`ps-1 bi ${
                            visibleSecrets[data?.uuid]
                              ? "bi-eye-slash"
                              : "bi-eye"
                          }`}
                          style={{ cursor: "pointer", fontSize: "14px" }}
                          onClick={() => toggleSecretVisibility(data?.uuid)}
                        ></i>
                      </span>
                      <p
                        style={{
                          margin: "unset",
                          color: "rgba(145, 146, 147, 1)",
                        }}
                        className="pt-2 responsive-text-access"
                      >
                        {t("added")} {formatFromNow(data.created)}
                      </p>
                    </div>

                    <div className="d-flex flex-column justify-content-between align-items-end">
                      <div className="d-flex gap-2">
                        <p
                          className={`${
                            data?.connection?.connected === true
                              ? "bg-soft-success text-success"
                              : "bg-soft-danger text-danger"
                          } py-1 px-3 rounded fs-6`}
                        >
                          {data?.connection?.connected === true
                            ? t("Connected")
                            : t("Not Connected")}
                        </p>
                        {data?.primary === true && (
                          <p className="bg-soft-primary text-primary py-1 px-3 rounded fs-6">
                            {t("Primary")}
                          </p>
                        )}
                      </div>

                      <div className="d-none d-sm-flex gap-3 align-self-end">
                        <button
                          className="btn btn-outline-primary py-1 px-3"
                          onClick={() => {
                            setSelectedCreds(data);
                            setModalState(true);
                          }}
                          onMouseEnter={() => setHoverItem(`ad-edit-${index}`)}
                          onMouseLeave={() => setHoverItem(null)}
                        >
                          <i style={{ paddingRight: "7px" }}>
                            <EditIcon
                              fill={
                                hoverItem === `ad-edit-${index}`
                                  ? "#fff"
                                  : "#377dff"
                              }
                            />
                          </i>
                          <span>{t("Edit")}</span>
                        </button>
                        <button
                          className="btn btn-outline-danger py-1 px-3"
                          onClick={() => handleDelete(data?.uuid)}
                          onMouseEnter={() =>
                            setHoverItem(`ad-delete-${index}`)
                          }
                          onMouseLeave={() => setHoverItem(null)}
                        >
                          <i style={{ paddingRight: "7px" }}>
                            <DeleteIcon
                              stroke={
                                hoverItem === `ad-delete-${index}`
                                  ? "#fff"
                                  : "#ED4C78"
                              }
                            />
                          </i>
                          <span>{t("Delete")}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex d-sm-none gap-3 px-4 pt-3"
                    style={{ borderTop: "1px solid rgba(255, 255, 255, 0.1)" }}
                  >
                    <button
                      className="btn btn-outline-primary py-1 px-3 w-50 text-start"
                      onClick={() => {
                        setSelectedCreds(data);
                        setModalState(true);
                      }}
                      onMouseEnter={() => setHoverItem(`ad-edit-${index}`)}
                      onMouseLeave={() => setHoverItem(null)}
                    >
                      <i style={{ paddingRight: "7px" }}>
                        <EditIcon
                          fill={
                            hoverItem === `ad-edit-${index}`
                              ? "#fff"
                              : "#377dff"
                          }
                        />
                      </i>
                      <span>{t("Edit")}</span>
                    </button>
                    <button
                      className="btn btn-outline-danger py-1 px-3 w-50 text-start"
                      onClick={() => handleDelete(data?.uuid)}
                      onMouseEnter={() => setHoverItem(`ad-delete-${index}`)}
                      onMouseLeave={() => setHoverItem(null)}
                    >
                      <i style={{ paddingRight: "7px" }}>
                        <DeleteIcon
                          stroke={
                            hoverItem === `ad-delete-${index}`
                              ? "#fff"
                              : "#ED4C78"
                          }
                        />
                      </i>
                      <span>{t("Delete")}</span>
                    </button>
                  </div>
                </div>
              ))}
          </div>
          <div
            className="mt-2 text-primary"
            onClick={() => {
              setSelectedCreds(null);
              setModalState(true);
            }}
            style={{ cursor: "pointer" }}
          >
            + {t("Add Access Details")}
          </div>
        </div>
      </div>
      {modalState && (
        <AccessDetailModal
          getAccessDetailsData={getAccessDetailsData}
          accessDetailsData={accessDetailsData}
          id={id}
          selectedCreds={selectedCreds}
          setSelectedCreds={selectedCreds}
          modalState={modalState}
          domain={domain}
          setModalState={setModalState}
        />
      )}
    </>
  );
}

export default AccessDetailsSection;
